
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.596 14.334l.037-.292-.237-.175C1.626 12.567.5 10.422.5 7.983.5 3.87 3.875.5 8 .5s7.5 3.37 7.5 7.483c0 2.437-1.124 4.577-2.986 5.877l-.249.174.04.3 1.1 8.483.003.029.007.028a.448.448 0 01-.192.46l-.041.028-.034.034-.013.009a.29.29 0 01-.135.045l-.132-.001a.929.929 0 01-.073-.005l-.038-.023-4.5-2.694L8 20.573l-.257.154-4.482 2.684c-.277.133-.473.097-.584.023a.448.448 0 01-.192-.46l.007-.029.004-.029 1.1-8.582zm7.85 7.152l.874.519-.124-1.01-.7-5.688-.082-.67-.617.274c-.829.368-1.759.556-2.797.556-1.038 0-1.968-.188-2.797-.556l-.617-.274-.082.67-.7 5.688-.125 1.01.876-.519 3.2-1.896.011-.006.011-.008a.41.41 0 01.446 0l.01.008.012.006 3.2 1.896zM8 1.496c-3.575 0-6.5 2.917-6.5 6.487 0 3.57 2.925 6.488 6.5 6.488s6.5-2.917 6.5-6.488c0-3.57-2.925-6.487-6.5-6.487z","fill":"#748190","stroke":"#108999"}})])
          )
        }
      }
    